import { render, staticRenderFns } from "./BtPrefilters.vue?vue&type=template&id=25415be6&scoped=true&"
import script from "./BtPrefilters.vue?vue&type=script&lang=js&"
export * from "./BtPrefilters.vue?vue&type=script&lang=js&"
import style0 from "./BtPrefilters.vue?vue&type=style&index=0&id=25415be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25415be6",
  null
  
)

export default component.exports